import { useEffect, useState } from "react";
import { useGameStore } from "../../store/gameStore";

const MEDIA_MS = 2600;
const BUILTIN_MS = 1150;

// Full-screen "you just traveled through a portal" moment — plays ONLY on the screen of whoever
// actually went through (checked via member_id, mirroring the isMine pattern used across the
// other trigger modals). If the GM uploaded their own video/GIF for this Door/Portal it plays
// that; otherwise a built-in swirling-vortex flash stands in for it.
export default function PortalTransitionOverlay({ myMemberId }) {
  const pending = useGameStore((s) => s.pendingPortalTransition);
  const setPending = useGameStore((s) => s.setPendingPortalTransition);
  const [visible, setVisible] = useState(false);

  const isMine = pending && pending.member_id === myMemberId;
  const isVideo = /\.(mp4|webm|mov)(\?|$)/i.test(pending?.media_url || "");

  useEffect(() => {
    if (!isMine) return;
    setVisible(true);
    if (!pending.media_url) {
      const t = setTimeout(() => { setVisible(false); setPending(null); }, BUILTIN_MS);
      return () => clearTimeout(t);
    }
  }, [pending?.member_id, pending?.media_url]);

  if (!isMine || !visible) return null;

  const close = () => { setVisible(false); setPending(null); };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black pointer-events-none overflow-hidden" data-testid="portal-transition-overlay">
      {pending.media_url ? (
        isVideo ? (
          <video
            src={pending.media_url}
            autoPlay muted playsInline
            onEnded={close}
            onError={close}
            className="w-full h-full object-contain"
            data-testid="portal-transition-video"
          />
        ) : (
          <img
            src={pending.media_url}
            alt="Portal transition"
            onLoad={() => setTimeout(close, MEDIA_MS)}
            onError={close}
            className="w-full h-full object-contain"
            data-testid="portal-transition-gif"
          />
        )
      ) : (
        <>
          <div className="absolute inset-0 portal-flash bg-gradient-to-br from-[#a855f7]/70 via-black to-[#1E3A8A]/70" />
          <div className="portal-vortex-ring w-40 h-40 rounded-full border-8 border-[#D4AF37]" />
          <div className="portal-vortex-ring w-40 h-40 rounded-full border-4 border-[#a855f7]" style={{ animationDelay: "0.12s" }} />
        </>
      )}
      {pending.door_name && (
        <p className="absolute bottom-10 text-[#f1e0c5]/70 text-sm font-display tracking-widest uppercase">{pending.door_name}</p>
      )}
    </div>
  );
}
